// extracted by mini-css-extract-plugin
module.exports = {"input":"FormSelectRegion_input__cc0K3"};